module.exports = __webpack_public_path__ + "img/big3.95cdc72b.png";